import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccessMandateInstructions',
  props: {
  mandateInfo: { type: Object as PropType<{ reference?: string, url?: string}>, required: true },
},
  setup(__props) {

const props = __props;



const creditorInfo = computed(() => ({
  name: 'Guestplan',
  id: 'NL40ZZZ342518280000',
  address: 'Keizersgracht 188, Amterdam, 1016NA, NL',
}));

const subtitle = `${i18n.t('label.arrange_sepa_debit_your_bank')} ${i18n.t('label.sepa_debit_note_duration')}`;

async function showPaymentMethodMandate() {
  const newWin = window.open(
    props.mandateInfo?.url,
    'invoiceWindow',
    'height=600,width=600',
  );
  newWin!.document.close();
  newWin!.focus();
}


return { __sfc: true,props, creditorInfo, subtitle, showPaymentMethodMandate, PaymentResultSuccessLayout }
}

})